<p-dialog [(visible)]="onDevice" [closable]="true" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '75vw', height: '75vh' }">
	<ng-template pTemplate="header">
		<div class="d-flex">
			<fa-icon [icon]="['far', 'mobile-android']" class="me-4" size="2x"></fa-icon>
			<div class="display-8 ms-1 my-auto">Device {{ onDevice.mac?.toUpperCase() || 'unassigned' }}</div>
		</div>
		<p-divider></p-divider>
	</ng-template>

	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'cogs']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Settings</div>
			</ng-template>
			<app-on-device-settings [(onDevice)]="onDevice" (changesToSaveChange)="changesToSave = $event"></app-on-device-settings>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'id-badge']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">License</div>
			</ng-template>
			<app-on-license-modes [(onDevice)]="onDevice" (changesToSaveChange)="changesToSave = $event"></app-on-license-modes>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'starfighter-twin-ion-engine']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Features</div>
			</ng-template>
			<app-on-device-features [(onDevice)]="onDevice" (changesToSaveChange)="changesToSave = $event"></app-on-device-features>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'credit-card-front']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Payment</div>
			</ng-template>
			<app-on-device-payment [(onDevice)]="onDevice" (changesToSaveChange)="changesToSave = $event"></app-on-device-payment>
		</p-tabPanel>
	</p-tabView>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]=""
			[hideSave]=""
			(onCancelChange)="onDeviceChange.emit(undefined)"
			(onDeleteChange)="releaseLicense()"
			(onSaveChange)="onSave()"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]="!changesToSave"
			deleteLabel="Release device"
			[deletePromptOverride]="true"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
